export const INITIAL_REGISTER_TEXTS = {
    TOAST_MESSAGES: {
        PASSWORD_REQUIREMENTS: (
            <div>
                <p>Tu contraseña debe incluir:</p>
                -Entre 8 a 16 caracteres<br></br>
                -Al menos una letra mayúscula.<br></br>
                -Al menos una letra minúscula.<br></br>
                -Al menos un carácter especial (!@#$%^&*_=+;:,.?/~-) <br></br>
            </div>
        ),
        INVALID_EMAIL: "El correo electrónico ingresado no es válido. Por favor, verifica.",
        INVALID_PHONE: "El número de teléfono ingresado no es válido, debe contar con 10 dígitos. Por favor, verifica.",
        PASSWORD_MISMATCH: "La contraseña debe coincidir.",
        FILL_ALL_FIELDS: "No tan rápido McQueen, por favor llena todos los campos.",
        ACCEPT_TERMS: "Debes aceptar nuestros términos y condiciones"
    },
    MAIN_TITLE: "Crea tu Wuuju-cuenta♡",
    TERMS_TEXT: "He leído y estoy de acuerdo con los ",
    TERMS_LINK_TEXT: "términos y condiciones del servicio",
    PRIVACY_POLICY_LINK_TEXT: "política de privacidad",
    ALREADY_HAVE_ACCOUNT: "¿Ya tienes una Wuuju-cuenta?.",
    LOGIN_LINK_TEXT: "Inicia sesión"
};